import i18next from 'i18next';
import { brazil } from 'shared';
import { OpportunityContactRoleType } from './types';

export const getTranslatedRole = (role: string): string => {
  switch (role) {
    case OpportunityContactRoleType.CO_ISSUER:
      return i18next.t('contactRoleCoIssuer');
    case OpportunityContactRoleType.GROWER:
      return i18next.t('contactRoleGrower');
    case OpportunityContactRoleType.GUARANTOR:
      return i18next.t('contactRoleGuarantor');
    case OpportunityContactRoleType.OTHER:
      return i18next.t('contactRoleOther');
    case OpportunityContactRoleType.PRIMARY:
      return i18next.t('primaryContact');
    case OpportunityContactRoleType.SPOUSE:
      return i18next.t('contactRoleSpouse');
    default:
      return role;
  }
};

export const getOpportunityContactRoleType = (role: string | undefined): OpportunityContactRoleType | undefined => {
  switch (role) {
    case 'Co-Emitente':
      return OpportunityContactRoleType.CO_ISSUER;
    case 'Grower':
      return OpportunityContactRoleType.GROWER;
    case 'Guarantor':
      return OpportunityContactRoleType.GUARANTOR;
    case 'Landlord':
      return OpportunityContactRoleType.LANDLORD;
    case 'Other':
      return OpportunityContactRoleType.OTHER;
    case 'Partner':
      return OpportunityContactRoleType.SPOUSE;
    case 'Primary':
      return OpportunityContactRoleType.PRIMARY;
    default:
      return undefined;
  }
};

export const getFormattedTaxIdentifier = (taxIdentifier: string | undefined): string | undefined => {
  const isCnpj = taxIdentifier?.length === 14;
  return taxIdentifier
    ? isCnpj
      ? brazil.cnpjInputMask(taxIdentifier)
      : brazil.cpfInputMask(taxIdentifier)
    : undefined;
};
